import { useState } from "react";
import Modal from "../common/Modal";
import { useToast } from "../../hooks/useToast";


function ModalEditGroup({ group, onClose, onSave }) {
  const [name, setName] = useState(group.NOMBRE || "");
  const [enabled, setEnabled] = useState(
    group.ACTIVO === 1 || group.ACTIVO === "1"
  );
  const toast = useToast();

  const handleSubmit = async () => {
  //console.log("🔵 handleSubmit chiamato");
  //console.log("🔵 group object:", group);
  //console.log("🔵 name:", name);
  //console.log("🔵 enabled:", enabled);
    if (!name.trim()) {
      //console.log("🔴 Nome vuoto");
      toast.error("El nombre del grupo no puede estar vacío");
      return;
    }

    const updatedGroup = {
      COD_ID: group.COD_ID,
      COD_CLIENTE: group.COD_CLIENTE,
      NOMBRE: name.trim(),
      ACTIVO: enabled ? "1" : "0",
    };

    // console.log("📤 Payload da inviare:", updatedGroup);

    try {
      const result = await onSave(updatedGroup);
      //console.log("📥 Risultato onSave:", result);
      if (result?.status === "Error") {
        toast.error("Error al guardar cambios del grupo.");
        return;
      }

      toast.success("Cambios guardados correctamente.");
      onClose();
    } catch (err) {
      toast.error(err.message || "Error al guardar cambios del grupo");
      console.error("Error al guardar grupo:", err);
    }
  };

  return (
    <Modal title={`Editar grupo: ${group.NOMBRE}`} onClose={onClose}>
      <div className="input-group">
        <label className="label">Nombre del grupo</label>
        <input
          className="input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="input-group">
        <label className="label">Grupo habilitado</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => setEnabled(e.target.checked)}
          />
          Activo
        </label>
      </div>

      <div
        className="input-group_row"
        style={{ justifyContent: "center", gap: "1rem" }}
      >
        <span className="boton_opciones" onClick={handleSubmit}>
          Aceptar
        </span>
        <span className="boton_cancelar" onClick={onClose}>
          Cancelar
        </span>
      </div>
    </Modal>
  );
}

export default ModalEditGroup;
